import { useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useMemo } from 'react'

import { useDispatch } from 'store'
import { actions } from 'store/users'
import { createCustomTracker } from 'tracker/tracker'

export type PageViewEventProperties = {
  location: string
  mainFeature: string
}

export const useTracker = () => {
  const dispatch = useDispatch()

  // eslint-disable-next-line
  return (eventName: string, eventProperties?: any) => {
    // eslint-disable-next-line
    dispatch(actions.event({ eventName, eventProperties }))
  }
}

export const useTrackPageView = ({
  eventProperties,
  skipCondition = false,
}: {
  eventProperties: PageViewEventProperties
  skipCondition: boolean
}) => {
  const theme = useTheme()
  /* exclusively call isMobile here because it required to use noSsr = true
   * to prevent unexpected falsy value from useMediaQuery on server-side rendering
   */
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true })
  const tracker = useMemo(() => createCustomTracker({ gtm: true, userRecorder: true }), [])

  useEffect(() => {
    if (!skipCondition) {
      tracker?.trackEvent('page_view', {
        page_url: window.location.href,
        location: eventProperties.location,
        screen_experience: isMobile ? 'mobile' : 'desktop',
        main_feature: eventProperties.mainFeature,
      })
    }
  }, [tracker, isMobile, eventProperties.location, eventProperties.mainFeature, skipCondition])
}
